const scoreEvents = new EventTarget();

export const ScoreEventType = {
    CHANGED: 'score:changed'
};

export function publishScoreChanged(score) {
    scoreEvents.dispatchEvent(new CustomEvent(ScoreEventType.CHANGED, {
        detail: {
            redScore: score.redScore,
            blueScore: score.blueScore
        }
    }));
}

export function subscribeToScoreChanges(listener) {
    function handleScoreChanged(event) {
        listener(event.detail);
    }

    scoreEvents.addEventListener(ScoreEventType.CHANGED, handleScoreChanged);

    return () => {
        scoreEvents.removeEventListener(ScoreEventType.CHANGED, handleScoreChanged);
    };
}
